import React from 'react'
import { HttpErrorProps } from '../../../../hooks/useHttpError'
import { GenericError } from '../../generic/genericError'

export interface DataTableErrorProps extends HttpErrorProps {}

export function DataTableErrorHandler(props) {
  if (props?.errorCode === undefined) {
    return null
  }

  return <DataTableError {...props}></DataTableError>
}

export const DataTableError: React.FC<DataTableErrorProps> = props => {
  return props?.errorCode !== undefined ? (
    <GenericError
      errorCode={props.errorCode}
      onRefresh={props.onRefresh}
      onReportError={props.onReportError}
    />
  ) : null
}
